export enum DepartmentType {
  Department = 0,
  Entity = 1,
  UserGroup = 2
}